import { render, staticRenderFns } from "./multiselectelement.vue?vue&type=template&id=1bdc2864&scoped=true"
import script from "./multiselectelement.vue?vue&type=script&lang=js"
export * from "./multiselectelement.vue?vue&type=script&lang=js"
import style0 from "./multiselectelement.vue?vue&type=style&index=0&id=1bdc2864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdc2864",
  null
  
)

export default component.exports